import SvgIcon from '@mui/material/SvgIcon';
import React, { useState, useEffect } from 'react';
import  Logo from '../assets/logo.svg'


export default function SitemarkIcon() {
  return (
     <img src={Logo} className="IconStyle"/>
  );
}
